<template>
    <div class="screenSecurity" id="nav" :style="'font-size:18px'">
        <ScaleBox :width="1920" :height="1080" bgc="transparent" :delay="100">
            <div class="pageTop">
                <dv-decoration-8 :reverse="true" style="width:600px;height:65px;position: absolute;top: 0;left:0;" />
                <div style="position: absolute;top: 0;left:20px;">
                    <span></span>
                </div>
                <h1 style="line-height:60px;text-align: center;">江苏国际人才大厦
                </h1>
                <dv-decoration-8 style="width:600px;height:65px;position: absolute;top: 0;right:0;" />
                <div style="position: absolute;top:5px;right:20px;font-size: 20px;">
                    <div><span style="margin-right:30px;color:#29D1FF">{{ nowTime }}</span>{{ getWeek }}</div>
                </div>
            </div>
            <div class="page">
                <div class="changeFloor">
                    <div v-for="(item, index) in floorShowList"
                        :class="floorIndex == item.floorCode ? 'floorShow' : 'floor'"
                        :style="isHaveFloor(item.floorCode) ? ' border: 1px solid #FDCC8C;color:#FDCC8C; animation: twinkle 0.5s infinite alternate;' : ''"
                        @click="changeFloor(item.floorCode)">{{ item.floorName }}</div>
                </div>
                <div class="pageImg">
                    <img ref="imgRef" @load="loadImage" style="height:100%" mode="heightFix"
                        :src="require('../../assets/imgs/build' + floorIndex + '.png')" />
                    <div v-if="item.leftPercent" v-for="(item, index) in pointDataCamera"
                        :style="'position:absolute;left:' + (item.leftPercent - 1) + '%;' + 'top:' + (item.rightPercent - 2) + '%;'">
                        <div @click="getRtspUrl(item)" style="color: #ffffff;">
                            <img v-if="isHaveCamera(item)" :style="'cursor: pointer;width:40px;height:40px;'"
                                src="../../assets/imgs/dangerCamera.gif" />
                            <img v-else :style="'cursor: pointer;width:40px;height:40px;'"
                                src="../../assets/imgs/cameraBuild.png" />
                        </div>
                    </div>
                    <div v-if="item.leftPercent" v-for="(item, index) in placeList" :key="index"
                        :style="'position:absolute;left:' + (item.leftPercent - 1) + '%;' + 'top:' + (item.rightPercent - 2) + '%;'">
                        <div style="color: #ffffff;font-size: 20px;">
                            {{ item.placeName }}
                        </div>
                    </div>
                </div>
                <transition name='fade'>
                    <div v-show="leftDivShow" class="leftDiv" ref="getheight" @click="closeLeft">
                        <div ref="getTopHeight">
                            <dv-decoration-7 style="width:100%;height:60px;margin-top: 10px;">设备</dv-decoration-7>
                            <dv-border-box-13 style="width:100%;height:180px;">
                                <div style="display:flex;height:100%;justify-content: space-around;
                                                                                align-items: center;">
                                    <div>
                                        <dv-decoration-9 :dur="30" style="width:120px;" v-proportion="1">{{
                                            this.pointDataCamera.length
                                        }}</dv-decoration-9>
                                        楼层设备
                                    </div>
                                    <div>
                                        <dv-decoration-9 :dur="30" style="width:120px;" v-proportion="1">{{
                                            this.config.length
                                        }}</dv-decoration-9>
                                        总设备
                                    </div>

                                </div>
                            </dv-border-box-13>
                            <!-- <dv-decoration-7
                            style="width:100%;height:10%;margin-top: 10px;margin-bottom: 10px;">总览</dv-decoration-7> -->

                            <dv-decoration-11 style="width:200px;height:60px;margin:0 auto;">总览</dv-decoration-11>
                        </div>

                        <dv-border-box-12 :color="['#69B1DC', '#06DC28']"
                            :style="'width:100%;height:' + useHeight + 'px;padding: 10px 0;'">
                            <div v-for="(item, index) in configArr" :key="index" class="configList" :style="'height:55px'">
                                <div>
                                    {{ item.aliasName }}
                                </div>
                                <!-- <div v-proportion="1" :style="'width:17px'" :class="item.status ? 'yes' : 'no'">
                                </div> -->
                            </div>
                        </dv-border-box-12>
                    </div>
                </transition>
                <transition name='fade'>
                    <div v-show="!leftDivShow" class="leftShowButton">
                        <img @click.prevent="openLeft()" src="../../assets/imgs/openleft.png"
                            :style="'cursor: pointer;width:40px;z-index:99999'" mode="widthFix" />
                    </div>
                </transition>
                <transition name="moveR">
                    <div class="right" ref="abnormalHeight" v-show="rightDivShow" @click="closeRight">
                        <dv-border-box-8 :color="['#11B94B', '#FF1300']" :dur="8" style="padding:10px">
                            <div ref="titleHeight" class="abnormalTitle" :style="'line-height:60px'">
                                异常事件</div>
                            <div>
                                <div @click.stop="openThing(item)" v-for="(item, index) in thingListArr" :key="index"
                                    class="abnormals"
                                    :style="index % 2 != 0 ? 'background-color:rgba(111, 117, 134, 0.3)' : ''">
                                    <div>
                                        <div><span>事件ID：</span>{{ item.id }}</div>
                                        <div><span>事件类型：</span>{{ item.eventDesc }}</div>
                                        <div><span>发生时间：</span>{{ item.startTime ? item.startTime.split("T")[0]
                                            + " " + item.startTime.split("T")[1].split(".")[0] : ""
                                        }}</div>
                                        <div><span>发生场所：</span>{{ item.cameraAlias }}</div>
                                        <!-- <div><span>安全等级：</span>{{ item.actionLevel }}</div> -->
                                    </div>
                                </div>
                            </div>
                        </dv-border-box-8>
                    </div>
                </transition>
                <transition name='moveR'>
                    <div v-show="!rightDivShow" class="rightShowButton">
                        <img @click="openRight()" src="../../assets/imgs/openright.png"
                            :style="'cursor: pointer;width:40px;z-index:99999'" mode="widthFix" />
                    </div>
                </transition>
                <div class="bottomDiv">
                    <dv-border-box-12 style="width:350px" v-proportion="0.6">
                        <div class="text-x" ref="vlcContainerLeftRef1" >
                        </div>
                    </dv-border-box-12>
                    <dv-border-box-12 style="width:350px" v-proportion="0.6">
                        <div class="text-x" ref="vlcContainerLeftRef2">
                        </div>
                    </dv-border-box-12>
                    <dv-border-box-12 style="width:350px" v-proportion="0.6">
                        <div class="text-x" ref="vlcContainerLeftRef3">
                        </div>
                    </dv-border-box-12>
                    <dv-border-box-12 style="width:350px" v-proportion="0.6">
                        <div class="text-x" ref="vlcContainerLeftRef4">
                        </div>
                    </dv-border-box-12>
                </div>

            </div>

            <el-dialog :title="rtspTitle" :visible.sync="rtspUrlShow" width="50%" append-to-body
                :close-on-click-modal="false" center>
                <div ref="vlcShow" style="width:100%;margin 0 auto;" v-proportion="0.56"></div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" size="small" @click="rtspUrlShow = false">确 定</el-button>
                </span>
            </el-dialog>
        </ScaleBox>
    </div>
</template>

<script>
import { createVlcPluginObject } from '@/utils/index'
import ScaleBox from 'vue2-scale-box'
export default {
    components: {
        ScaleBox
    },
    data() {
        return {
            thingList: [],
            rtspUrlShow: false,
            rtspUrl: "",
            rtspTitle: "",
            dangerCamera: [],
            dangerFloor: [],
            floorShowList: [],
            pointDataCamera: [],

            timer: null,
            timer2: null,
            configArr: [],
            abnormalArr: [],
            abnormal: [],
            config: [],
            useHeight: 0,
            itemHeight: 0,
            imgScale: 0,
            mouseX: 0,
            mouseTX: 0,
            leftDivShow: true,
            rightDivShow: true,
            floorIndex: "1020",
            query: {
                buildingCode: "",
                //楼宇编码
                buildingName: "",
                //楼宇名称
                floorCode: "",
                //楼层编码
                floorName: "",
                //楼层名称
                placeCode: "",
                //场所编码
                placeName: "",
                //场所名称
                placeType: "",
                //场所类型
            },
            placeList: [],
            timer3: null,
            nowTime: new Date(),
            getWeek: "",
            thingListArr: [],
            thingPage: 0,
        };
    },
    watch: {

    },
    mounted() {
        //不用刷新
        this.getCameraList();




    },
    created() {
        let loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });


        setTimeout(() => {
            loading.close();
        }, 3000);
        //不用刷新
        this.getFloorList();
        this.getCameraList();
        this.nowTimes();

        this.change();
        //需要刷新 


        // this.timer3 = setInterval(() => {
        this.getThingList();
        // }, 10000);

    },
    beforeDestroy() {
        clearInterval(this.timer)
        clearInterval(this.timer2)
        clearInterval(this.timer3)
        this.clear();
    },
    methods: {
        openUrl() {
            alert(1)
        },
        openThing(item) {
            // alert(1)
            console.log(item)
        },
        getThingList() {
            let selectForm = { //查询条件
                "buildingCode": "",
                "floorCode": ""
            };
            this.dangerCamera = []
            this.thingList = [];
            this.dangerFloor = [];
            // /securityIncident/getAlarmList
            this.$http.post(`/api/safe/securityIncident/getAlarmList`, selectForm).then(res => {
                if (res.data.code == 200) {
                    this.thingList = res.data.data;
                    this.thingList.forEach(element => {
                        this.dangerCamera.push(element.actionCameraIp)
                        this.dangerFloor.push(element.floorCode)

                    });
                    //需要刷新 
                    this.abnormalHeightSet();
                }
            })
        },
        getCameraList() {
            this.$http.post("/api/safe/ipChannel/queryList").then(res => {
                if (res.data.code == '200') {
                    this.config = res.data.data;
                    this.heightSet();
                }
            }).catch(error => {
            });
        },
        getCameraPoint() {
            this.pointDataCamera = []
            this.$http.post("/api/safe/place/getCameraInfoList", { floorCode: this.floorIndex }).then(res => {
                if (res.data.code == "200") {
                    res.data.data.forEach(element => {
                        if (element.yAxis) {
                            this.pointDataCamera.push(element)
                        }
                    });
                    this.loadImage();
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        //显示当前时间（年月日时分秒）
        timeFormate(timeStamp) {
            let year = new Date(timeStamp).getFullYear();
            let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
            let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
            let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
            let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
            let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
            let week = new Date(timeStamp).getDay();
            let weeks = ["日", "一", "二", "三", "四", "五", "六"];
            let getWeek = "星期" + weeks[week];
            this.getWeek = year + "年" + month + "月" + date + "日";
            this.nowTime = hh + ":" + mm + ':' + ss + " " + getWeek;
        },
        nowTimes() {
            this.timeFormate(new Date());
            setInterval(this.nowTimes, 1000);
            this.clear()
        },
        clear() {
            clearInterval(this.nowTimes)
            this.nowTimes = null;
        },
        getRtspUrl(item) {
            this.rtspUrl = ""
            this.rtspTitle = item.aliasName;
            this.$http.post("/api/safe/video/getRtspUrl", { ip: item.cameraIp }).then(res => {
                if (res.data.code == "200") {
                    this.rtspUrlShow = true;
                    this.rtspUrl = res.data.data
                    // let mainUrl = "rtsp://admin:hik123456@192.168.0.64:554/Streaming/Channels/1";
                    this.getShowRealVideo('vlcShow', this.rtspUrl, (html) => {
                        this.$refs.vlcShow.innerHTML = html;
                    });
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },

        //获取楼层信息
        getFloorList() {
            this.floorShowList = [];
            this.$http.post("/api/safe/area/floor/getList", {}).then(res => {
                if (res.data.code == "200") {
                    this.floorShowList = res.data.data[0].floorInfos
                    this.changeFloor();
                    // this.floorIndex = this.floorShowList[0].floorCode
                }
            })
        },
        changeFloor(floorIndex) {
            this.floorIndex = floorIndex || this.floorIndex;
            let index = this.dangerFloor.indexOf(this.floorIndex)
            if (index != -1) {
                this.dangerFloor.splice(index, 1);
            }

            let item = this.getFloorInfo(this.floorIndex)
            this.query.floorCode = this.floorIndex
            this.query.floorName = item.floorName
            this.query.buildingCode = item.buildingCode
            this.query.buildingName = item.buildingName
            this.getPlaceList();
            this.getCameraPoint();
        },
        getPlaceList() {
            this.placeList = []
            this.$http.post("/api/safe/place/getList", this.query).then(res => {
                if (res.data.code == "200") {
                    this.placeList = res.data.data
                    this.loadImage();
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        getFloorInfo(floorCode) {
            let item = this.floorShowList.find(item => {
                return item.floorCode == floorCode;
            });
            return item
        },
        openLeft() {
            this.leftDivShow = true;
        },
        closeLeft() {
            this.leftDivShow = false;
        },
        openRight() {
            this.rightDivShow = true;
        },
        closeRight() {
            this.rightDivShow = false;
        },
        loadImage() {
            //加载完图片回调
            let imgRef = this.$refs.imgRef; //img的dom
            //有真实图片款高用注释部分，没有就用标签高度
            // this.imgNaturalData.width = imgRef.naturalWidth; //图片原始宽度
            // this.imgNaturalData.height = imgRef.naturalHeight; //图片原始高度
            // this.imgNaturalData.width = imgRef.width; //图片标签宽度
            // this.imgNaturalData.height = imgRef.height; //图片标签高度

            let rect = this.$refs.imgRef.getBoundingClientRect();
            this.imgScale = rect.height / 700; //现在图片和真实图片比例
            // alert(this.imgScale)
            // this.isImage = true;
            // this.handlePointListDatahandlePointListData(this.imgScale);
        },
        heightSet() {
            let height = this.$refs.getheight.offsetHeight;
            let topHeight = this.$refs.getTopHeight.offsetHeight;
            // alert(height)
            // alert(topHeight)
            let useHeight = height - topHeight - 10
            this.useHeight = useHeight;
            this.itemHeight = 55;
            let pageNum = Math.trunc((useHeight) / this.itemHeight)
            let pageSize = Math.ceil(this.config.length / pageNum)
            if (this.config.length > pageNum) {
                let page = 1;
                this.configArr = this.config.slice(0, pageNum)
                this.timer = setInterval(() => {
                    page++;
                    if (page < pageSize) {
                        this.configArr = this.config.slice(pageNum * (page - 1), pageNum * page)
                    } else if (page == pageSize) {
                        this.configArr = this.config.slice(pageNum * (page - 1), this.config.length)
                        page = 0
                    }
                }, 2000);
            } else {
                this.configArr = this.config
            }



        },
        abnormalHeightSet() {
            let height = this.$refs.abnormalHeight.offsetHeight;
            let titleHeight = this.$refs.titleHeight.offsetHeight;
            let useHeight = height - titleHeight - 10
            // this.thingList
            let pageNum = Math.trunc(useHeight / 135) - 1
            let pageSize = Math.ceil(this.thingList.length / pageNum)
            this.thingPage = 1;
            this.thingListArr = this.thingList.slice(0, pageNum)
            this.timer2 = setInterval(() => {
                this.thingPage++;
                if (this.thingPage < pageSize) {
                    this.thingListArr = this.thingList.slice(pageNum * (this.thingPage - 1), pageNum * this.thingPage)
                } else if (this.thingPage == pageSize) {
                    this.thingListArr = this.thingList.slice(pageNum * (this.thingPage - 1), this.thingList.length)
                    this.thingPage = 0
                }
            }, 5000);
        },

        isHaveCamera(val) {
            if (this.dangerCamera.indexOf(val.cameraIp) != -1) {
                return true
            } else {
                return false
            }
        },
        isHaveFloor(val) {
            if (this.floorIndex != val && this.dangerFloor.indexOf(val) != -1) {
                return true
            } else {
                return false
            }
        },


        change(val) {
            // if (val) {
            // 	this.getImgs(val)
            // 	let arr = this.data.filter(item => {
            // 		return item.cameraId == val
            // 	});
            let arr = [
                'rtsp://admin:njfxds123@192.168.3.109:554/Streaming/Channels/1',
                'rtsp://admin:njfxds123@192.168.3.136:554/Streaming/Channels/1',
                'rtsp://admin:njfxds123@192.168.3.132:554/Streaming/Channels/1',
                'rtsp://admin:njfxds123@192.168.3.182:554/Streaming/Channels/1'
            ]
            this.getShowRealVideo('vlcContainerLeftRef1', arr[0], (html) => {
                this.$refs.vlcContainerLeftRef1.innerHTML = html;
            });
            this.getShowRealVideo('vlcContainerLeftRef2', arr[1], (html) => {
                this.$refs.vlcContainerLeftRef2.innerHTML = html;
            });
            this.getShowRealVideo('vlcContainerLeftRef3', arr[2], (html) => {
                this.$refs.vlcContainerLeftRef3.innerHTML = html;
            });
            this.getShowRealVideo('vlcContainerLeftRef4', arr[3], (html) => {
                this.$refs.vlcContainerLeftRef4.innerHTML = html;
            });
            // 	if (arr.length > 0) {
            // arr.forEach(element => {
            //     // let mainUrl = "rtsp://admin:hik123456@192.168.0.64:554/Streaming/Channels/1";

            // });


            // 	} else {
            // 		console.error('无选中的ipChannelNum');
            // 	}

            // } else {
            // 	this.$refs.vlcContainerRightRef.innerHTML = '';
            // }
        },
        getShowRealVideo(refDiv, mainUrl, fn) {

            this.$nextTick(() => {
                let dom = this.$refs[refDiv];
                let rect = dom.getBoundingClientRect();
                let containerHtml = createVlcPluginObject({
                    width: rect.width,
                    height: rect.height,
                    rtspUrl: mainUrl
                });
                fn && fn(containerHtml);
                // this.$refs.vlcContainerRef.innerHTML = containerHtml;
            });
        },
        getDate() {
            const nowDate = new Date();
            const date = {
                year: nowDate.getFullYear(),
                month: nowDate.getMonth() + 1,
                date: nowDate.getDate(),
            };
            const newmonth = date.month >= 10 ? date.month : "0" + date.month;
            const day = date.date >= 10 ? date.date : "0" + date.date;
            return date.year + "-" + newmonth + "-" + day;
        },

    },


};
</script>

<style lang="scss">
.screenSecurity {

    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.5s linear;
        transform: translateX(0);
    }

    .fade-enter,
    .fade-leave-to {
        transform: translateX(-100%);
    }

    .moveR-enter-active,
    .moveR-leave-active {
        transition: all 0.5s linear;
        transform: translateX(0);
    }

    .moveR-enter,
    .moveR-leave,
    .moveR-leave-to {
        transform: translateX(100%);
    }

    width: 100%;
    color: #ffffff;
    height:100%;
    text-align: center;
    background-color: rgb(52, 64, 92);
    transform: translateZ(0);

    .page {
        // border: 1px solid #000;
        position: relative;
        overflow-x: auto;
        overflow-y: hidden;
        flex: 1;

        .changeFloor {
            position: absolute;
            left: 15%;
            top: 30px;
            display: flex;
            z-index: 9999;

            .floor {
                margin-left: 20px;
                border: 1px solid #e2e2e271;
                color: #e2e2e271;
                padding: 10px 20px;
                border-radius: 10px;
                cursor: pointer;
            }

            .floorShow {
                margin-left: 20px;
                border: 1px solid #ffffff;
                color: #ffffff;
                padding: 10px 20px;
                border-radius: 10px;
                cursor: pointer;
            }
        }

        .pageImg {
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
        }

        .leftShowButton {
            height: 100%;
            display: flex;
            align-items: center;
            z-index: 9999;
            top: 50px;
        }

        .leftDiv {
            width: 300px;
            position: fixed;
            left: 0;
            // background-color: rgba(111, 117, 134, 0.3);
            text-align: center;
            height: calc(100% - 50px - 12px);
            top: 50px;

            .configList {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-left: 35px;
                margin-right: 35px;

                .yes {
                    background-color: #00d011;
                    border-radius: 50%;
                }

                .no {
                    background-color: #b2b2b2;
                    border-radius: 50%;
                }
            }
        }

        .rightShowButton {
            position: fixed;
            right: 0;
            height: 100%;
            display: flex;
            align-items: center;
            top: 50px;
        }

        .right {
            width: 330px;
            height: calc(100% - 50px - 12px);
            position: fixed;
            top: 50px;
            right: 0;

            .abnormalTitle {
                background: linear-gradient(to top right, rgb(125, 231, 252, 0.3), rgba(111, 117, 134, 0.3));
                text-align: left;
                padding-left: 20%;
            }

            .abnormals {
                margin-top: 15px;
                height: 135px;
                text-align: left;
                padding-left: 20px;
                line-height: 33px;
                border: 1px solid #cccccc;
                border-radius: 10px;
            }
        }

        .bottomDiv {
            .text-x {
                width: 280px;
                height: 158px;
                margin-left: 9px;
                margin-top: 11px;
            }

            width: calc(100% - 610px);
            height: auto;
            position: fixed;
            left: 300px;
            bottom: 12px; // background-color: rgba(111, 117, 134, 0.3);
            display: flex;
        }
    }
}

@keyframes twinkle {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0.6;
    }
}
</style>
